export const chargingTransactioStatusEnum = {
  Unset: "Unset",
  Pending: "Pending",
  Success: "Success",
  Failure: "Failure",
  Finished: "Finished",
  WaitingToChargeToken: "WaitingToChargeToken",
  WaitingToCreateInvoice: "WaitingToCreateInvoice",
  Complete: "Complete",
};
